import { render, staticRenderFns } from "./DeclaracaoConcessionariaCadastro.vue?vue&type=template&id=17e4d8df&scoped=true&"
import script from "./DeclaracaoConcessionariaCadastro.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoConcessionariaCadastro.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoConcessionariaCadastro.vue?vue&type=style&index=0&id=17e4d8df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e4d8df",
  null
  
)

export default component.exports